import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { EmissionsSummary,
  EmissionsLeversResponse,
} from '@/types/emissions';

export function useEmissionsSummary() {
  return useQuery<EmissionsSummary>({
    queryKey: ['emissions', 'summary'],
    queryFn: async () => {
      const { data } = await api.get<EmissionsSummary>('/emissions/summary');
      return data;
    },
    staleTime: 60_000,
  });
}

/**
 * Peer-relative reduction levers — which vehicles to replace, which to rotate.
 * Separate from the summary: that answers "how much CO2", this answers
 * "what do we actually do about it".
 */
export function useReductionLevers() {
  return useQuery<EmissionsLeversResponse>({
    queryKey: ['emissions', 'reduction-levers'],
    queryFn: async () => {
      const { data } = await api.get<EmissionsLeversResponse>(
        '/emissions/reduction-levers',
      );
      return data;
    },
    staleTime: 60_000,
  });
}
